<template>
    <CicPopup
        :title="item.groupId ? 'Edit Origination Group' : 'New Origination Group'"
        :saveable="editing"
        class="no-padding"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <ul class="item-form">
            <li class="form-label">
                {{ $t('Group Name') }}
            </li>
            <li>
                <CicTextbox
                    id="group_name"
                    :enabled="editing"
                    :value="item.name"
                    :maxlength="32"
                    @input="(val) => updateFieldValue('name', val)"
                />
            </li>
            <template v-if="!item.groupId && $store.hasRight('VIEW_ACCESS_TYPE_4')">
                <li class="form-label">
                    {{ $t('Type') }}
                </li>
                <li>
                    <CicSelect
                        id="group_type"
                        :enabled="editing"
                        :value="item.type"
                        :options="[
                            { value: 'CLI', label: $t('CLI') },
                            { value: 'Email', label: $t('Email') },
                        ]"
                        @input="(val) => updateFieldValue('type', val)"
                    />
                </li>
            </template>
            <li class="form-label">
                {{ $t('Description') }}
            </li>
            <li>
                <CicTextbox
                    id="group_description"
                    :enabled="editing"
                    :value="item.description"
                    :maxlength="128"
                    @input="(val) => updateFieldValue('description', val)"
                />
            </li>
        </ul>
        <br />
        <table id="group_member_table" class="cic-table">
            <thead>
                <tr>
                    <th>{{ $t(item.type === 'Email' ? 'Email Address or Domain' : 'CLI or Prefix') }}</th>
                    <th>{{ $t('Description') }}</th>
                    <th v-if="editing" class="td-checkbox"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(member, memberIndex) in item.members">
                    <td>
                        <CicTextbox
                            :enabled="editing"
                            :value="member.name"
                            :max-length="32"
                            @input="(val) => updateMember(memberIndex, 'name', val)"
                        />
                    </td>
                    <td>
                        <CicTextbox
                            :enabled="editing"
                            :value="member.description"
                            :max-length="128"
                            @input="(val) => updateMember(memberIndex, 'description', val)"
                        />
                    </td>
                    <td v-if="editing">
                        <IconButton icon="remove-icon" @click="removeMember(memberIndex)" />
                    </td>
                </tr>
                <tr v-if="editing">
                    <td colspan="2"></td>
                    <td>
                        <IconButton icon="add-icon" @click="addMember" />
                    </td>
                </tr>
            </tbody>
        </table>
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import IconButton from '@/components/controls/IconButton';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import CicSelect from '@/components/inputs/CicSelect';

    export default {
        name: 'EditOriginationGroup',
        components: {
            CicSelect,
            CicPopup,
            CicTextbox,
            IconButton,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = !this.item.groupId || this.$store.hasRight('EDIT_CLI_GROUPS');
        },
        methods: {
            addMember() {
                const members = JSON.parse(JSON.stringify(this.item.members));
                members.push({ name: null, description: null });
                this.updateFieldValue('members', members);
            },

            removeMember(index) {
                const members = JSON.parse(JSON.stringify(this.item.members));
                members.splice(index, 1);
                this.updateFieldValue('members', members);
            },

            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },

            updateMember(index, field, value) {
                const members = JSON.parse(JSON.stringify(this.item.members));
                members[index][field] = value;
                this.updateFieldValue('members', members);
            },
        },
    };
</script>
